import React, { useCallback, useEffect, useState } from "react";
import { apiClient } from "../lib/apiClient";
import { DueContact, contactKindLabel, dueLabel, todayYmd } from "../lib/contactLog";

// "Follow-ups due" on the watchlist tab (#3208): open follow-ups dated today or
// earlier, oldest first. Marking one done removes it; clicking opens the property.

interface Props {
  /** Open a property by id (the dashboard knows how to select it). */
  onOpenProperty: (propertyId: string) => void;
}

const FollowUpsDue: React.FC<Props> = ({ onOpenProperty }) => {
  const [rows, setRows] = useState<DueContact[]>([]);

  const load = useCallback(async () => {
    try {
      const { data } = await apiClient.get<{ data: DueContact[] }>("/contacts/due");
      setRows(data.data || []);
    } catch {
      setRows([]); // best effort: no list rather than a broken tab
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (rows.length === 0) return null;
  const today = todayYmd();

  const done = async (id: string) => {
    setRows((rs) => rs.filter((r) => r.id !== id));
    try {
      await apiClient.patch(`/contacts/${id}/done`);
    } catch {
      load();
    }
  };

  return (
    <section className="followups-due" aria-label="Follow-ups due">
      <h3>
        Follow-ups due <span className="followups-count">{rows.length}</span>
      </h3>
      <ul>
        {rows.map((r) => (
          <li key={r.id}>
            <button type="button" className="followups-open" onClick={() => onOpenProperty(r.propertyId)}>
              {r.address ? `${r.address}${r.city ? `, ${r.city}` : ""}` : "A property outside your plan"}
            </button>
            <span className="followups-meta">
              {r.followUpOn ? dueLabel(r.followUpOn, today) : ""} · {contactKindLabel(r.kind)}
              {r.note ? ` · ${r.note.length > 60 ? `${r.note.slice(0, 57)}…` : r.note}` : ""}
            </span>
            <button type="button" className="map-buybox-clear" onClick={() => done(r.id)}>
              Done
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FollowUpsDue;
